module.exports = __webpack_public_path__ + "img/aha-slides-gpt-2.479b2910.webp";